<script setup lang="ts">
import TgIcon from '@/assets/images/social/telegram.svg'
import VkIcon from '@/assets/images/social/vk.svg'

const SOCIAL_NETWORKS_LINKS = [
  {
    key: 'vk',
    href: 'https://vk.com/farfordostavka',
    image: VkIcon,
  },
  {
    key: 'telegram',
    href: 'https://t.me/farfordostavkaTG',
    image: TgIcon,
  },
]
</script>

<template>
  <div class="social-networks">
    <span class="social-networks__text">Делись с друзьями:</span>

    <nuxt-link
      v-for="link in SOCIAL_NETWORKS_LINKS"
      :key="link.key"
      :href="link.href"
      target="_blank"
      class="social-networks__link"
    >
      <nuxt-img
        class="social-networks__image"
        :src="link.image"
        :alt="link.key"
      />
    </nuxt-link>
  </div>
</template>

<style scoped lang="scss">
.social-networks {
  display: flex;
  gap: 16px;
  align-items: center;

  &__text {
    font-size: 14px;
    font-weight: 800;
  }

  &__link {
    width: 46px;
    height: 46px;
    color: $background-dark;
  }

  &__image {
    width: 100%;
    height: 100%;
  }

  @include media('>=tablet') {
    &__link {
      width: 56px;
      height: 56px;
    }
  }

  @include media('>=desktop-mini') {
    &__text {
      font-size: 16px;
    }
  }
}
</style>
